/* ==========================================================================
   Mondō London — catalogue register disclosure
   Filtering is server-rendered by Shopify. JavaScript only collapses and opens
   the panel; native filter URLs remain complete without scripting.
   ========================================================================== */
(function () {
  'use strict';
  var reg = document.querySelector('[data-register]');
  if (!reg) return;

  // filter panel toggle (panel is open-by-default without JS; .js CSS collapses it)
  var toggle = reg.querySelector('[data-reg-toggle]');
  var panel = reg.querySelector('[data-reg-panel]');
  if (toggle && panel) {
    var startsOpen = Boolean(panel.querySelector('[aria-current="true"]'));
    panel.classList.toggle('is-open', startsOpen);
    toggle.setAttribute('aria-expanded', startsOpen ? 'true' : 'false');
    toggle.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
})();

/* ==========================================================================
   Desktop card hover image deferral (every card surface — refine.js is global).
   The alternate photograph is promoted on precise-pointer intent and is only
   allowed to fade in after it has loaded. Touch cards use the separate tap
   controller below and never expose this placeholder through sticky :hover.
   ========================================================================== */
(function () {
  'use strict';
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function load(img) {
    var source = img.getAttribute('data-src');
    if (!source) return;
    function ready() {
      img.classList.add('is-loaded');
      img.removeAttribute('data-src');
    }
    img.addEventListener('load', ready, { once: true });
    img.src = source;
    if (img.complete && img.naturalWidth > 1) ready();
  }

  function promote(e) {
    var card = e.target.closest ? e.target.closest('[data-card]') : null;
    if (!card) return;
    var img = card.querySelector('.alt-img[data-src]');
    if (!img) return;
    load(img);
  }
  document.addEventListener('pointerover', promote);
  document.addEventListener('focusin', promote);
})();

/* ==========================================================================
   Product-card temporary alternate preview.

   A touch or pen tap on the image reveals the first alternate photograph for
   four seconds. The featured photograph remains underneath, so returning to it
   only removes one state class. The caption and every other part of the card
   remain the native product link. Fine pointers retain normal link navigation.
   ========================================================================== */
(function () {
  'use strict';
  if (!window.matchMedia) return;

  var coarseCards = window.matchMedia('(any-pointer: coarse)');
  var previewDuration = 4000;
  var lastPointer = null;

  function previewFor(target) {
    return target && target.closest ? target.closest('[data-card-preview]') : null;
  }

  function resetPreview(preview) {
    if (preview._cardPreviewTimer) clearTimeout(preview._cardPreviewTimer);
    preview._cardPreviewTimer = 0;
    preview.classList.remove('is-previewing');
  }

  function revealPreview(preview, image) {
    resetPreview(preview);
    image.classList.add('is-loaded');
    preview.classList.add('is-previewing');
    preview._cardPreviewTimer = setTimeout(function () {
      resetPreview(preview);
    }, previewDuration);
  }

  function loadAndReveal(preview) {
    var image = preview.querySelector('.alt-img');
    if (!image) return false;

    var source = image.getAttribute('data-src');
    if (!source) {
      if (image.classList.contains('is-loaded') || (image.complete && image.naturalWidth > 1)) {
        revealPreview(preview, image);
      }
      return true;
    }
    if (preview._cardPreviewLoading) return true;

    var settled = false;
    var token = (preview._cardPreviewToken || 0) + 1;
    preview._cardPreviewToken = token;
    preview._cardPreviewLoading = true;

    function cleanup() {
      image.removeEventListener('load', ready);
      image.removeEventListener('error', fail);
      if (preview._cardPreviewToken === token) preview._cardPreviewLoading = false;
    }

    function ready() {
      if (settled) return;
      settled = true;
      cleanup();
      if (preview._cardPreviewToken !== token) return;
      image.removeAttribute('data-src');
      revealPreview(preview, image);
    }

    function fail() {
      if (settled) return;
      settled = true;
      cleanup();
    }

    image.addEventListener('load', ready, { once: true });
    image.addEventListener('error', fail, { once: true });
    image.setAttribute('src', source);
    if (image.complete && image.naturalWidth > 1) ready();
    return true;
  }

  function acceptsTap(event, preview) {
    var pointerType = event.pointerType || '';
    if (lastPointer && lastPointer.preview === preview) {
      // Mobile Safari and some embedded browsers may expose a touch contact as
      // a later mouse-like click. The originating pointerdown is authoritative.
      pointerType = lastPointer.pointerType || pointerType;
    }
    lastPointer = null;
    if (pointerType) return pointerType === 'touch' || pointerType === 'pen';
    return coarseCards.matches;
  }

  document.addEventListener('pointerdown', function (event) {
    lastPointer = {
      pointerType: event.pointerType || '',
      preview: previewFor(event.target)
    };
  }, { capture: true, passive: true });

  document.addEventListener('pointercancel', function () {
    lastPointer = null;
  }, { capture: true, passive: true });

  document.addEventListener('click', function (event) {
    if (event.detail === 0 || !event.target || !event.target.closest) return;
    var preview = previewFor(event.target);
    if (!preview || !acceptsTap(event, preview) || !preview.querySelector('.alt-img')) return;
    event.preventDefault();
    event.stopPropagation();
    loadAndReveal(preview);
  }, true);
})();
